import { Key, useEffect, useRef } from 'react';
import { EventCardItem } from 'components/eventCardItem';
import { EventObject } from 'components/eventCardItem/EventCardItem.types';
import InsideLoader from 'components/loader/InsideLoader';
import { useApiCall } from 'hooks/axiosHooks';
import { findEventOfDate } from 'utils/calendarUtils';
import { MonthPill } from 'components/eventPagination/monthPill';
import { PendingEventPaginationProps } from './PendingEventPagination.types';

const PendingEventPagination = ({
  selectedDates,
}: PendingEventPaginationProps) => {
  // TODO: implement scrolling with pagination
  // Params page: number, isPast: boolean
  // const { data: events, refetch: refetchEvent } = useGetPendingEventsQuery({
  //   page: 0,
  // });
  const {
    data: events,
    refetch: refetchEvent,
    isFetching,
    isLoading,
  } = useApiCall();

  const loadEvents = () => {
    refetchEvent(`event/pending?page=0`);
  };

  useEffect(() => {
    loadEvents();
  }, []);

  // category pills
  const categoryPillsRef = useRef<string[]>([]);

  useEffect(() => {
    // clear the category pills on every render
    categoryPillsRef.current = [];
  });

  // scroll to the selected date related events
  useEffect(() => {
    if (selectedDates && selectedDates.length > 0 && events) {
      const found = findEventOfDate([...events], selectedDates[0]);
      if (found) {
        const element = document.getElementById(found.event?._id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
  }, [selectedDates, events]);

  return (
    <div>
      {isFetching && <InsideLoader />}
      {events && !events?.length && (
        <div className="text-center text-white">
          <p>No events found</p>
        </div>
      )}
      <div className="flex gap-3 flex-col">
        {events?.map((event: EventObject, index: Key | null | undefined) => (
          // <>
          // {/* Use for month pill */}
          // {/* <MonthPill pillRef={categoryPillsRef} event={event?.event} /> */}
          <div key={index} className="mb-2" id={event?.event?._id}>
            <EventCardItem
              id={event?.event?._id}
              key={index}
              eventData={event?.event}
              variant={'response'}
              additionalVariants={event?.variantData}
            />
          </div>
          // </>
        ))}
      </div>
    </div>
  );
};

export default PendingEventPagination;
